import React from 'react';
import logger from '../../lib/logger';

// Error boundaries must be class components — React doesn't support
// functional components for componentDidCatch yet.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    logger.error('Uncaught error:', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-bg flex items-center justify-center px-4">
        <div className="text-center max-w-sm">
          <div className="text-6xl mb-6">⚽</div>
          <h1 className="font-display text-3xl tracking-widest text-wrong mb-3">
            OWN GOAL
          </h1>
          <p className="text-dimText text-sm leading-relaxed mb-6">
            Something went wrong on our end. The error has been logged and we'll look into it.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="bg-accent text-bg text-sm font-semibold rounded-xl px-6 py-3 hover:bg-accent/90 transition-colors mr-3"
          >
            Reload page
          </button>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); }}
            className="border border-border text-dimText text-sm rounded-xl px-6 py-3 hover:border-accent hover:text-white transition-colors"
          >
            Try again
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre className="mt-6 text-left text-[10px] text-wrong/70 bg-surface2 border border-border rounded-xl p-4 overflow-auto max-h-48">
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      </div>
    );
  }
}
